import {Button, Modal} from 'antd'
import React, {useEffect, useState} from 'react'
import {EditOutlined} from '@ant-design/icons'
import {ToDoTypeInput} from './ToDoTypeInput'
import {CustomType} from '../../entities/journalRecord'
import {PostgrestError} from '@supabase/supabase-js'

export type ToDoTypeEditButtonProps = {
  userType: CustomType
  onEditType: (editedType: CustomType) => Promise<
    | {
        success: true
        data: CustomType
      }
    | {
        success: false
        error: PostgrestError
      }
  >
}

export function ToDoTypeEditButton(props: ToDoTypeEditButtonProps) {
  const [modalOpen, setModalOpen] = useState(false)
  const [newUserType, setNewUserType] = useState(props.userType)

  return (
    <>
      <Modal
        open={modalOpen}
        onOk={async () => {
          const result = await props.onEditType(newUserType)
          if (result.success) {
            setNewUserType(props.userType)
            setModalOpen(false)
          }
        }}
        onCancel={() => setModalOpen(false)}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          style={{paddingRight: '20px'}}
        >
          <ToDoTypeInput userType={newUserType} setUserType={setNewUserType} />
        </div>
        {/* <Button
          type="primary"
          onClick={async () => {
            const result = await toDoService.createUserToDoType(newUserType.name, newUserType.icon)
            if (result.success) {
              setNewUserType({id: null, icon: '🧑‍🌾', name: ''})
            }
          }}
        ></Button> */}
      </Modal>
      <Button
        type="link"
        color="primary"
        icon={<EditOutlined />}
        onClick={() => {
          setNewUserType(props.userType)
          setModalOpen(true)
        }}
      ></Button>
    </>
  )
}
